// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"37aca469f963ee9d8e81","678":"9ca47d059e116b2e96ab","883":"f810f3b459712524a74e"}[chunkId] + ".js";
};